import { useReveal } from "../lib/useReveal";

interface Metric {
  key: string;
  name: string;
  target: string;
  /** Width of the "good" band as a percentage of the bar (real CWV boundaries). */
  goodPct: number;
  /** Cumulative width of good + needs-improvement bands. */
  niPct: number;
}

// Boundaries published in Google's Core Web Vitals guidance; bars are scaled so the
// "good" band ends at the documented threshold. No measured values are implied.
const METRICS: Metric[] = [
  { key: "LCP", name: "Largest Contentful Paint", target: "≤ 2.5 s", goodPct: 50, niPct: 80 },
  { key: "INP", name: "Interaction to Next Paint", target: "≤ 200 ms", goodPct: 33, niPct: 83 },
  { key: "CLS", name: "Cumulative Layout Shift", target: "≤ 0.10", goodPct: 33, niPct: 83 },
];

export function WebVitals(): React.ReactElement {
  const { ref, shown } = useReveal(0.35);

  return (
    <div ref={ref} className={`viz viz-vitals${shown ? " is-shown" : ""}`}>
      <div className="vitals-caption">
        <span className="eyebrow">PERFORMANCE BUDGETS</span>
        <p>We build to Google&rsquo;s Core Web Vitals &ldquo;good&rdquo; thresholds &mdash; the bar below each metric ends where the green budget runs out.</p>
      </div>
      <ul className="vitals-list">
        {METRICS.map((metric, index) => (
          <li
            key={metric.key}
            className="vitals-row"
            style={{ "--row-delay": `${index * 160}ms` } as React.CSSProperties}
          >
            <div className="vitals-head">
              <strong>{metric.key}</strong>
              <span>{metric.name}</span>
              <em>{metric.target}</em>
            </div>
            <div className="vitals-bar" role="img" aria-label={`${metric.name}: good is ${metric.target}`}>
              <span className="vitals-seg vitals-good" style={{ flexBasis: `${metric.goodPct}%` }} />
              <span className="vitals-seg vitals-ni" style={{ flexBasis: `${metric.niPct - metric.goodPct}%` }} />
              <span className="vitals-seg vitals-poor" style={{ flexBasis: `${100 - metric.niPct}%` }} />
              <span className="vitals-flag" style={{ left: `${metric.goodPct}%` }}>
                {metric.target}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
